import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from 'bootbox';
import toastr from 'toastr/toastr'
import 'toastr/toastr.scss'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.min'
import 'bootstrap-table/dist/locale/bootstrap-table-es-ES.min'
import 'bootstrap-table/dist/extensions/custom-view/bootstrap-table-custom-view'
import 'bootstrap-table/dist/extensions/toolbar/bootstrap-table-toolbar'
import 'bootstrap-slider/src/js/bootstrap-slider'

export default class extends Controller {
    connect() {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }

        let table = $('#table');
        let admin_table = $('#admin_table');
        let table_page = $('#table_page');

        table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 10,
            pageList: "[10, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }
        });

        admin_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: false,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }
        });

        $("#range-start-time").slider({
            // tooltip: 'always',
            focus: true
        });
        $("#range-price").slider({
            // tooltip: 'always',
            focus: true
        });
        $("#range-duration").slider({
            // tooltip: 'always',
            focus: true
        });
        $("#range-adults").slider({
            // tooltip: 'always',
            focus: true
        });
        $("#range-childrens").slider({
            // tooltip: 'always',
            focus: true
        });
        $("#range-pax").slider({
            // tooltip: 'always',
            focus: true
        });

        table_page.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            advancedSearch: "true",
            pageSize: 6,
            pageList: "[6, 12, 18, 24, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            customViewDefault: "true",
            showCustomView: "true",
            showCustomViewButton: "true",
        });
        $('#checkBtn').on('change', function () {
            $('.inputBtnDataTable').prop('checked', $(this).is(':checked'));
        })

        window.customViewFormatter = data => {
            const template = $('#profileTemplatePage').html()
            let view = ''

            $.each(data, function (i, row) {
                view += template.replace('%ID_GM%', row.id)
                    .replace('%IMG_CAT%', row.img_cat_card)
                    .replace('%PROD_NAME%', row.prod_name)
                    .replace('%PROD_NAME2%', row.prod_name)
                    .replace('%MOD_NAME%', row.mod_name)
                    .replace('%DEST_NAME%', row.dest_name)
                    .replace('%ADULT%', row.adult)
                    .replace('%CHILDREN%', row.children)
                    .replace('%MOD_DESC%', row.mod_desc)
                    .replace('%PAX%', row.pax)
                    .replace('%FROM_PRICE%', row.from_price)
                    .replace('%DETAILS%', row.details)
            })

            return `<div class="row mx-0">${view}</div>`
        }

        table_page.bootstrapTable('toggleCustomView');
    }

    delete(e) {
        bootbox.confirm({
            title: "Eliminar",
            message: "¿Seguro que desea eliminar este elemento?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/delete',
                        data: {},
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })
    }

    /* Para Hotetec */
    restore(e) {
        bootbox.confirm({
            title: "Restaurar",
            message: "¿Seguro que desea restaurar este hotel?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {},
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })
    }

    /* Para Hotetec */
    delete_booking(e) {
        bootbox.confirm({
            title: "Cancelar",
            message: "¿Seguro que desea cancelar esta reserva?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {},
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                                if (data.redirect_url) {
                                    window.location.href = `${data.redirect_url}?redirect=true`;
                                }
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                                if (data.redirect_url) {
                                    window.location.href = data.redirect_url;
                                }
                            }
                        }
                    })
                }
            }
        })
    }
    /* Para Hotetec FIN */

    /* Para Vouchers */
    delete_voucher(e) {
        bootbox.dialog({
            title: "Cancelar reserva",
            message: `
            <div class="form-group">
                <label for="motivo">Motivo de cancelación:</label>
                <textarea id="motivo" class="form-control" rows="3" placeholder="Describa detalladamente el motivo..."></textarea>
                <small class="text-muted">Este motivo quedará registrado en el sistema.</small>
            </div>`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No, volver',
                    className: 'btn-secondary'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> Sí, cancelar',
                    className: 'btn-danger',
                    callback: function() {
                        const motivo = $('#motivo').val();

                        if (!motivo || motivo.trim() === '') {
                            toastr.warning('Por favor, ingrese un motivo de cancelación');
                            return false; // Evita que se cierre el diálogo
                        }

                        $.ajax({
                            url: e.target.dataset.target,
                            data: {
                                motivo_cancelacion: motivo.trim(),
                                accion: 'cancelar_reserva'
                            },
                            type: 'POST', // Considera usar POST en lugar de GET
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    $('#table').bootstrapTable('refresh');
                                    if (data.redirect_url) {
                                        window.location.href = `${data.redirect_url}?redirect=true`;
                                    }
                                } else {
                                    toastr.error(data.msg);
                                    console.log(data.msg);
                                    if (data.redirect_url) {
                                        window.location.href = data.redirect_url;
                                    }
                                }
                            },
                            error: function(xhr, status, error) {
                                toastr.error('Error al procesar la cancelación');
                                console.error(error);
                            }
                        });
                    }
                }
            }
        });
    }

    continuous_voucher(e) {
        // Generar un ID único
        const uniqueId = `fecha_continuacion_${Date.now()}`;

        const dialog = bootbox.dialog({
            title: "Continuar reserva",
            message: `
            <div class="form-group">
                <label for="${uniqueId}">Fecha y hora:</label>
                <input type="text" id="${uniqueId}" class="form-control fecha-continuacion-input" placeholder="Seleccione fecha y hora" value="${e.target.dataset.todate}" />
                <small class="text-muted">Seleccione hasta cuándo desea continuar la reserva.</small>
            </div>`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> Continuar',
                    className: 'btn-success',
                    callback: function() {
                        const fecha = $(`#${uniqueId}`).val();

                        if (!fecha || fecha.trim() === '') {
                            toastr.warning('Por favor, seleccione una fecha y hora');
                            return false;
                        }

                        $.ajax({
                            url: e.target.dataset.target,
                            data: {
                                fecha_continuacion: fecha,
                                accion: 'continuar_reserva'
                            },
                            type: 'POST',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    $('#table').bootstrapTable('refresh');
                                    if (data.redirect_url) {
                                        window.location.href = `${data.redirect_url}?redirect=true`;
                                    }
                                } else {
                                    toastr.error(data.msg);
                                    console.log(data.msg);
                                    if (data.redirect_url) {
                                        window.location.href = data.redirect_url;
                                    }
                                }
                            },
                            error: function(xhr, status, error) {
                                toastr.error('Error al procesar la continuación de la reserva');
                                console.error(error);
                            }
                        });
                    }
                }
            }
        });

        // Esperar a que el diálogo esté completamente visible
        dialog.on('shown.bs.modal', function() {
            // Buscar el elemento flatpickr_controller en el DOM
            /*const flatpickrElement = document.querySelector('[data-controller="flatpickr"]');
            if (flatpickrElement && flatpickrElement.__controller) {
                // Si el controller está disponible, usar su método
                flatpickrElement.__controller.initializeFechaContinuacion(document.getElementById(uniqueId));
            } else {
                // Fallback: inicializar directamente*/
                const input = document.getElementById(uniqueId);
                if (input && !input._flatpickr) {
                    flatpickr(input, {
                        enableTime: true,
                        dateFormat: "d/m/y H:i",
                        altInput: true,
                        altFormat: "d/m/y H:i",
                        time_24hr: true,
                        minuteIncrement: 15,
                        minDate: input.value,
                        disableMobile: "true",
                        onChange: function(selectedDates, dateStr, instance) {
                            if (selectedDates[0] && selectedDates[0] < new Date()) {
                                toastr.warning('No puede seleccionar una fecha/hora pasada');
                                instance.clear();
                            }
                        }
                    });
                }
            /*}*/
        });
    }
    /* Marcar voucher como pago en efectivo */
    mark_as_cash(e) {
        bootbox.dialog({
            title: "Pago en efectivo",
            message: `
            <p>¿Está seguro de marcar esta reserva como &#8220;Pago en efectivo&#8221;?</p>
            <p>Se cancelar&#225; la solicitud de pago de LaberintoPago.</p>
            <hr>
            <div class="form-group">
                <label for="motivo_efectivo">Motivo:</label>
                <textarea id="motivo_efectivo" class="form-control" rows="3" placeholder="Explique por qu&#233; se pagar&#225; en efectivo..."></textarea>
                <small class="text-muted">Este motivo quedar&#225; registrado en el sistema para referencia futura.</small>
            </div>`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> S&#237;, marcar',
                    className: 'btn-success',
                    callback: function() {
                        const motivo = $('#motivo_efectivo').val();

                        if (!motivo || motivo.trim() === '') {
                            toastr.warning('Por favor, ingrese el motivo del pago en efectivo');
                            return false; // Evita que se cierre el diálogo
                        }

                        $.ajax({
                            url: e.target.dataset.target,
                            data: {
                                reason: motivo.trim()
                            },
                            type: 'POST',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    $('.table').bootstrapTable('refresh');
                                } else {
                                    toastr.error(data.msg);
                                    console.log(data.msg);
                                }
                            },
                            error: function(xhr, status, error) {
                                toastr.error('Error al marcar la reserva como pago en efectivo');
                                console.error(error);
                            }
                        });
                    }
                }
            }
        });
    }

    /* Desmarcar voucher como pago en efectivo */
    unmark_cash(e) {
        bootbox.confirm({
            title: "Desmarcar pago en efectivo",
            message: "¿Está seguro de desmarcar esta reserva como &#8220;Pago en efectivo&#8221;?<br><br>Se generar&#225; un nuevo link de pago de LaberintoPago y se reenviar&#225; el correo a la agencia.",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> S&#237;, desmarcar',
                    className: 'btn-warning'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {},
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('.table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        },
                        error: function(xhr, status, error) {
                            toastr.error('Error al desmarcar la reserva como pago en efectivo');
                            console.error(error);
                        }
                    })
                }
            }
        })
    }

    /* Para Vouchers FIN */

    block(e) {
        bootbox.confirm({
            message: "¿Seguro que desea bloquear el acceso y la renta a este usuario?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/block',
                        data: {},
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })
    }

    change_status(e) {
        bootbox.confirm({
            message: "¿Seguro que desea cambiar el estado de disponibilidad?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {},
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    commercial(e) {
        console.log(e);
        bootbox.confirm({
            message: "¿Seguro que desea poner este usuario como Comercial del sitio?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {},
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })
    }

    filterTable(e) {
        $(`#${e.target.dataset.table}`).bootstrapTable('refresh');
    }

    clearFilter(e) {
        let parentElement = $(`#${e.target.dataset.target}`);
        let input = parentElement.find('input[type="text"]');
        let input_checkbox = parentElement.find('input[type="checkbox"]');
        let input_hidden = parentElement.find('input[type="hidden"]');
        let select = parentElement.find('select');

        input.map((index, elem) => {
            elem.value = '';
        })
        input_checkbox.map((index, elem) => {
            elem.checked = false;
        })
        input_hidden.map((index, elem) => {
            elem.value = '';
        })
        select.map((index, elem) => {
            $(elem).val(null).trigger('change');
        })
    }

    filterTableFilters(e) {
        $(`#${e.target.dataset.table}`).bootstrapTable('refresh');
        $(`#${e.target.dataset.show}`).removeClass('show');
        $('#filters-grande')[0].classList.toggle('d-none');
    }

    async clearFilterFilters(e) {
        let parentElement = $(`#${e.target.dataset.target}`);
        let input = parentElement.find('input[type="checkbox"]');
        let select = parentElement.find('select');

        await new Promise((resolve) => {
            input.map((index, elem) => {
                $(elem).prop('checked', false);
            });
            select.map((index, elem) => {
                $(elem).val(null).trigger('change');
            });
            resolve(); // Indicamos que el bloque ha terminado
        });

        $("#range-start-time").slider('refresh', {});
        $("#range-price").slider('refresh', {});
        $("#range-duration").slider('refresh', {});
        $("#range-adults").slider('refresh', {});
        $("#range-childrens").slider('refresh', {});
        $("#range-pax").slider('refresh', {});

        this.filterTableFilters(e);
    }
}